export const formatCurrency = (amount) => {
  if (!amount || isNaN(Number(amount))) return "";
  amount = Number(amount);
  const currency = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
  return currency
};
